import { Signal1973xs1vkmdcb as Signal } from '../../../../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  get_rawSession1kjo1nj4tz6n0 as get_rawSession,
  lensUnread1tcpdysie4g78 as lensUnread,
  get_session9cytjmfbg8nd as get_session,
} from '../../../../../../sdk/UserSession.mjs';
import { handleOne3ny7r4k654tcd as handleOne } from '../../../../../../extensions/HasReadBy.ext.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { rememberSuspending3qo0upgbry9b as rememberSuspending } from '../../../../../../../../../reactive/com/lightningkite/reactive/core/RememberSuspending.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  get_px8ok5q0jdway2 as get_px,
  get_rem14pbkv8p42gid as get_rem,
  get_rem2p56fiaxda5jo as get_rem_0,
} from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { SectionSemantic_getInstance27qbv8tkwzf0w as SectionSemantic_getInstance } from '../../../../../theming/sections.mjs';
import { get_withoutPadding21hnjxk91b1qc as get_withoutPadding } from '../../../../../theming/appTheme.mjs';
import {
  dynamicThemexp3sdnaolntz as dynamicTheme,
  get_compact3lsezez8nz8b6 as get_compact,
} from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import {
  get_expanding10cuv3ua9vajx as get_expanding,
  get_centered1xfu6or5nc0lq as get_centered,
  forEach37zw770vd3h4l as forEach,
} from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  get_expandButtonTheme1dpdnzsv2lxs8 as get_expandButtonTheme,
  get_deleteButton1v46c8rhktdg5 as get_deleteButton,
  DangerButtonSemantic_getInstanceb7gofax87736 as DangerButtonSemantic_getInstance,
} from '../../../../../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../../../nav/AppDimensions.mjs';
import { unreadIconVisibley9o01zmxr3gz as unreadIconVisible } from '../../../../iconShortcuts.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance } from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import {
  expandIcon1as9er6lyg7in as expandIcon,
  expandAndMarkAsReadAction24de04tkd12ld as expandAndMarkAsReadAction,
} from '../../../../expansion.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  BoldSemantic_getInstance3sy4hmow8wwn9 as BoldSemantic_getInstance,
  body3i5t0n7zprpqb as body,
  smallBody2trfy14zwtona as smallBody,
} from '../../../../../theming/Titles.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { ButtonSemantic_getInstance2exl8jbak13ac as ButtonSemantic_getInstance } from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { Link2eefk0yp041c4 as Link } from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Link.commonHtml.mjs';
import { ChangeOrderForm23hgjlgmtvjevd as ChangeOrderForm2 } from '../ChangeOrderForm2.mjs';
import {
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance_0,
  Dimensions32ju1l7z4mh as Dimension,
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
} from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  get_edit2tiiawv2658bs as get_edit,
  get_trash3qsdn4kaynjmu as get_trash,
} from '../../../../../../icons.mjs';
import {
  resize3py5p2yrjp6p7 as resize,
  shownDefaultFalse3hpz4awymyomc as shownDefaultFalse,
} from '../../../../../../utils/utils.mjs';
import { icon1sxjaie5w1apt as icon } from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  shownWhenxgf1ujy6rmvr as shownWhen,
  weightt34o7llf2uyq as weight,
} from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import {
  Indent_Section_getInstance2f8fy630t595n as Indent_Section_getInstance,
  indented3383b46h9g40w as indented,
  space2ppi73m2qk1br as space,
} from '../../../../space.mjs';
import {
  get_unpadded3gipn3ftxgnwh as get_unpadded,
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
} from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { greySeparatory5mpcoeivng5 as greySeparator } from '../../../../../theming/separators.mjs';
import { ChangeItemReadReceipts_instance2jo5uerda8tke as ChangeItemReadReceipts_instance } from '../data.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { initMetadataForLambda3af3he42mmnh as initMetadataForLambda } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { get_dialogStackleaqvayyucjw as get_dialogStack } from '../../../../nav/crowpay.mjs';
import { GenericConfirmationDialog172k63mmx5r2d as GenericConfirmationDialog } from '../../../../../dialogs/GenericConfirmationDialog.mjs';
import { changeRequestItemButton3gsegq8wnygxl as changeRequestItemButton } from './renderIndividualDetails.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function renderDraftChangeOrder(_this__u8e3s4, changeOrder, changeItems) {
  var expanded = Signal().fak(false);
  var tmp = get_rawSession();
  var orderUnread = lensUnread(tmp, (session) => handleOne(session.hfv_1, ($this$handleOne, it) => $this$handleOne.baj(changeOrder)));
  var itemsUnread = rememberSuspending(VOID, VOID, VOID, renderDraftChangeOrder$slambda_0(changeItems));
  var unread = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.baj(orderUnread).sfw($this$remember.baj(itemsUnread)));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  view.zb8(get_px(0));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(false);
  dynamicTheme(view_0, ($this$dynamicTheme) => $this$dynamicTheme.baj(expanded) ? get_withoutPadding(SectionSemantic_getInstance()) : null);
  var tmp_0 = view_0.ibb(get_expanding(view_0), get_expandButtonTheme(view_0));
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (Button())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.ebb(p_1, view_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (RowOrCol())(view_1.pc());
  var tmp0_elvis_lhs_2 = view_1.cbb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
  view_1.ebb(p_2, view_2);
  view_2.xbm(false);
  view_2.zb8(get_AppDimensions().mg2_1);
  get_centered(view_2);
  unreadIconVisible(view_2, ($this$unreadIconVisible) => $this$unreadIconVisible.baj($this$unreadIconVisible.baj(unread)));
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.minus' call
  Companion_getInstance();
  view_2.jbb(get_centered(view_2), expandIcon(view_2, expanded));
  var tmp_1 = get_centered(view_2);
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (TextView())(view_2.pc());
  var tmp0_elvis_lhs_3 = view_2.cbb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
  view_2.ebb(p_3, view_3);
  view_3.jba(view_3.ob6_1.ybe(BodySemantic_getInstance()));
  var tmp_2 = KMutableProperty0();
  var tmp_3 = TextView$_get_content_$ref_4pzcwl(view_3);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(view_3));
  reactiveScope(view_3, ($this$reactiveScope) => {
    var c = $this$reactiveScope.baj(changeOrder);
    var tmp$ret$1 = 'Change #' + c.b58_1 + ': ' + c.s57_1;
    this_0.set(tmp$ret$1);
    return Unit_instance;
  });
  view_2.fbb(p_3, view_3);
  view_2.jbb(tmp_1, view_3);
  view_1.fbb(p_2, view_2);
  view_1.mbg(expandAndMarkAsReadAction(view_1, expanded, unread));
  view_0.fbb(p_1, view_1);
  view_0.jbb(tmp_0, view_1);
  var tmp_4 = view_0.ibb(get_compact(view_0), get_compact(view_0));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_4 = view_0.cbb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view_0 : tmp0_elvis_lhs_4;
  view_0.ebb(p_4, view_4);
  view_4.xbm(false);
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  var tmp_5 = view_4.hbb(ButtonSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.link' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (Link())(view_4.pc());
  var tmp0_elvis_lhs_5 = view_4.cbb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
  view_4.ebb(p_5, view_5);
  var tmp_6 = KMutableProperty0();
  var tmp_7 = Link$_get_to_$ref_jq7esp(view_5);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_1 = getPropertyCallableRef('to', 0, tmp_6, tmp_7, Link$_set_to_$ref_i9gu5x(view_5));
  reactiveScope(view_5, ($this$reactiveScope) => {
    var c = $this$reactiveScope.baj(changeOrder);
    var tmp$ret$16 = () => new (ChangeOrderForm2())(c.r57_1, c.q57_1);
    this_1.set(tmp$ret$16);
    return Unit_instance;
  });
  view_5.jbb(get_centered(view_5), icon(view_5, resize(get_edit(Companion_getInstance_0()), get_rem(1.1)), 'Edit Change Order'));
  view_4.fbb(p_5, view_5);
  view_4.jbb(tmp_5, view_5);
  var tmp_8 = get_deleteButton(view_4);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (Button())(view_4.pc());
  var tmp0_elvis_lhs_6 = view_4.cbb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view_4 : tmp0_elvis_lhs_6;
  view_4.ebb(p_6, view_6);
  shownDefaultFalse(view_6, ($this$shownDefaultFalse) => $this$shownDefaultFalse.baj(changeOrder).v57_1 == null);
  view_6.jbb(get_centered(view_6), icon(view_6, resize(get_trash(Companion_getInstance_0()), get_rem(1.1)), 'Delete Change Order Draft'));
  onClick(view_6, VOID, VOID, renderDraftChangeOrder$slambda_2(changeOrder));
  view_4.fbb(p_6, view_6);
  view_4.jbb(tmp_8, view_6);
  view_0.fbb(p_4, view_4);
  view_0.jbb(tmp_4, view_4);
  view.fbb(p_0, view_0);
  var tmp_9 = shownWhen(view, VOID, ($this$shownWhen) => $this$shownWhen.baj(expanded));
  // Inline function 'com.crowpay.views.components.sectionIndentCol' call
  // Inline function 'com.crowpay.views.components.indentedCol' call
  var indent = Indent_Section_getInstance();
  var tmp2 = indent.ygq_1;
  // Inline function 'com.crowpay.views.components.indentedCol' call
  var afterSpace = indent.zgq_1;
  var tmp_10 = get_unpadded(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_7 = new (Frame())(view.pc());
  var tmp0_elvis_lhs_7 = view.cbb_1;
  var p_7 = tmp0_elvis_lhs_7 == null ? view : tmp0_elvis_lhs_7;
  view.ebb(p_7, view_7);
  var tmp_11;
  var tmp_12 = null;
  if (!((tmp_12 == null ? null : new (Dimension())(tmp_12)) == null)) {
    tmp_11 = sizeConstraints(view_7, VOID, VOID, VOID, VOID, VOID, null);
  } else {
    tmp_11 = Companion_getInstance();
  }
  var tmp_13 = view_7.ibb(tmp_11, indented(view_7, tmp2, afterSpace));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_8 = new (RowOrCol())(view_7.pc());
  var tmp0_elvis_lhs_8 = view_7.cbb_1;
  var p_8 = tmp0_elvis_lhs_8 == null ? view_7 : tmp0_elvis_lhs_8;
  view_7.ebb(p_8, view_8);
  view_8.xbm(true);
  view_8.zb8(get_px(0));
  space(view_8, get_rem_0(1));
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_9 = new (TextView())(view_8.pc());
  var tmp0_elvis_lhs_9 = view_8.cbb_1;
  var p_9 = tmp0_elvis_lhs_9 == null ? view_8 : tmp0_elvis_lhs_9;
  view_8.ebb(p_9, view_9);
  view_9.jba(view_9.ob6_1.ybe(BodySemantic_getInstance()));
  var tmp_14 = KMutableProperty0();
  var tmp_15 = TextView$_get_content_$ref_4pzcwl_0(view_9);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_2 = getPropertyCallableRef('content', 0, tmp_14, tmp_15, TextView$_set_content_$ref_pketfb_0(view_9));
  reactiveScope(view_9, ($this$reactiveScope) => {
    var tmp$ret$32 = 'Description: ' + $this$reactiveScope.baj(changeOrder).t57_1;
    this_2.set(tmp$ret$32);
    return Unit_instance;
  });
  view_8.fbb(p_9, view_9);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_10 = new (RowOrCol())(view_8.pc());
  var tmp0_elvis_lhs_10 = view_8.cbb_1;
  var p_10 = tmp0_elvis_lhs_10 == null ? view_8 : tmp0_elvis_lhs_10;
  view_8.ebb(p_10, view_10);
  view_10.xbm(false);
  var tmp_16 = weight(view_10, 6.0);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_11 = new (Space())(view_10.pc());
  var tmp0_elvis_lhs_11 = view_10.cbb_1;
  var p_11 = tmp0_elvis_lhs_11 == null ? view_10 : tmp0_elvis_lhs_11;
  view_10.ebb(p_11, view_11);
  view_10.fbb(p_11, view_11);
  view_10.jbb(tmp_16, view_11);
  var tmp_17 = view_10.ibb(weight(view_10, 1.0), get_centered(view_10));
  // Inline function 'com.crowpay.views.theming.bodyBold' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_12 = new (TextView())(view_10.pc());
  var tmp0_elvis_lhs_12 = view_10.cbb_1;
  var p_12 = tmp0_elvis_lhs_12 == null ? view_10 : tmp0_elvis_lhs_12;
  view_10.ebb(p_12, view_12);
  view_12.jba(view_12.ob6_1.ybe(BodySemantic_getInstance().ybe(BoldSemantic_getInstance())));
  view_12.bbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp_18 = view_12.tb5_1;
  var tmp_19;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength('ID') === 0) {
    tmp_19 = '\xA0';
  } else {
    tmp_19 = 'ID';
  }
  tmp_18.fbu(tmp_19);
  view_10.fbb(p_12, view_12);
  view_10.jbb(tmp_17, view_12);
  var tmp_20 = view_10.ibb(weight(view_10, 1.0), get_centered(view_10));
  // Inline function 'com.crowpay.views.theming.bodyBold' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_13 = new (TextView())(view_10.pc());
  var tmp0_elvis_lhs_13 = view_10.cbb_1;
  var p_13 = tmp0_elvis_lhs_13 == null ? view_10 : tmp0_elvis_lhs_13;
  view_10.ebb(p_13, view_13);
  view_13.jba(view_13.ob6_1.ybe(BodySemantic_getInstance().ybe(BoldSemantic_getInstance())));
  view_13.bbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp_21 = view_13.tb5_1;
  var tmp_22;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength('Status') === 0) {
    tmp_22 = '\xA0';
  } else {
    tmp_22 = 'Status';
  }
  tmp_21.fbu(tmp_22);
  view_10.fbb(p_13, view_13);
  view_10.jbb(tmp_20, view_13);
  var tmp_23 = view_10.ibb(weight(view_10, 1.0), get_centered(view_10));
  // Inline function 'com.crowpay.views.theming.bodyBold' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_14 = new (TextView())(view_10.pc());
  var tmp0_elvis_lhs_14 = view_10.cbb_1;
  var p_14 = tmp0_elvis_lhs_14 == null ? view_10 : tmp0_elvis_lhs_14;
  view_10.ebb(p_14, view_14);
  view_14.jba(view_14.ob6_1.ybe(BodySemantic_getInstance().ybe(BoldSemantic_getInstance())));
  view_14.bbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp_24 = view_14.tb5_1;
  var tmp_25;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength('Date') === 0) {
    tmp_25 = '\xA0';
  } else {
    tmp_25 = 'Date';
  }
  tmp_24.fbu(tmp_25);
  view_10.fbb(p_14, view_14);
  view_10.jbb(tmp_23, view_14);
  view_8.fbb(p_10, view_10);
  greySeparator(view_8);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_15 = new (RowOrCol())(view_8.pc());
  var tmp0_elvis_lhs_15 = view_8.cbb_1;
  var p_15 = tmp0_elvis_lhs_15 == null ? view_8 : tmp0_elvis_lhs_15;
  view_8.ebb(p_15, view_15);
  view_15.xbm(true);
  view_15.zb8(get_px(0));
  forEach(view_15, changeItems, renderDraftChangeOrder$lambda);
  view_8.fbb(p_15, view_15);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_16 = new (Space())(view_8.pc());
  var tmp0_elvis_lhs_16 = view_8.cbb_1;
  var p_16 = tmp0_elvis_lhs_16 == null ? view_8 : tmp0_elvis_lhs_16;
  view_8.ebb(p_16, view_16);
  view_8.fbb(p_16, view_16);
  view_7.fbb(p_8, view_8);
  view_7.jbb(tmp_13, view_8);
  view.fbb(p_7, view_7);
  var tmp$ret$83 = view.jbb(tmp_10, view_7);
  view.jbb(tmp_9, tmp$ret$83);
  greySeparator(view, ($this$greySeparator) => {
    var tmp = KMutableProperty0();
    var tmp_0 = Separator$_get_shown_$ref_e9a0og($this$greySeparator);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('shown', 0, tmp, tmp_0, Separator$_set_shown_$ref_f1kfq4($this$greySeparator));
    reactiveScope($this$greySeparator, ($this$reactiveScope) => {
      var tmp$ret$84 = !$this$reactiveScope.baj(expanded);
      this_0.set(tmp$ret$84);
      return Unit_instance;
    });
    return Unit_instance;
  });
  _this__u8e3s4.fbb(p, view);
}
function *_generator_invoke__zhh2q8($this, $this$rememberSuspending, $completion) {
  var tmp = ChangeItemReadReceipts_instance;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.cha_1;
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp$ret$0 = tmp_0;
  var tmp_1 = tmp.th8(tmp$ret$0, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return tmp_1;
}
var renderDraftChangeOrder$slambdaClass;
function renderDraftChangeOrder$slambda() {
  if (renderDraftChangeOrder$slambdaClass === VOID) {
    class $ {
      constructor($changeItems) {
        this.cha_1 = $changeItems;
      }
      wah($this$rememberSuspending, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$rememberSuspending), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    renderDraftChangeOrder$slambdaClass = $;
  }
  return renderDraftChangeOrder$slambdaClass;
}
function renderDraftChangeOrder$slambda_0($changeItems) {
  var i = new (renderDraftChangeOrder$slambda())($changeItems);
  var l = ($this$rememberSuspending, $completion) => i.wah($this$rememberSuspending, $completion);
  l.$arity = 1;
  return l;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function Link$_get_to_$ref_jq7esp(p0) {
  return () => p0.xbv_1;
}
function Link$_set_to_$ref_i9gu5x(p0) {
  return (_this__u8e3s4) => {
    p0.ibw(_this__u8e3s4);
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8_0($this, confirmed, $completion) {
  if (confirmed) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_session();
    var tmp = await_0(this_0, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var tmp_0 = tmp.hfv_1;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = $this.dha_1;
    var tmp_1 = await_0(this_1, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    var tmp$ret$1 = tmp_1;
    var tmp_2 = tmp_0.kft(tmp$ret$1.q57_1).iem($completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
  }
  return Unit_instance;
}
var renderDraftChangeOrder$slambda$slambdaClass;
function renderDraftChangeOrder$slambda$slambda() {
  if (renderDraftChangeOrder$slambda$slambdaClass === VOID) {
    class $ {
      constructor($changeOrder) {
        this.dha_1 = $changeOrder;
      }
      cgk(confirmed, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, confirmed), $completion);
      }
      s2(p1, $completion) {
        return this.cgk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    renderDraftChangeOrder$slambda$slambdaClass = $;
  }
  return renderDraftChangeOrder$slambda$slambdaClass;
}
function renderDraftChangeOrder$slambda$slambda_0($changeOrder) {
  var i = new (renderDraftChangeOrder$slambda$slambda())($changeOrder);
  var l = (confirmed, $completion) => i.cgk(confirmed, $completion);
  l.$arity = 1;
  return l;
}
var renderDraftChangeOrder$slambdaClass_0;
function renderDraftChangeOrder$slambda_1() {
  if (renderDraftChangeOrder$slambdaClass_0 === VOID) {
    class $ {
      constructor($changeOrder) {
        this.eha_1 = $changeOrder;
      }
      sao($completion) {
        var tmp = get_dialogStack();
        var tmp_0 = DangerButtonSemantic_getInstance();
        tmp.xgd(new (GenericConfirmationDialog())('Delete Draft?', 'You are about to delete this change order draft. Deleted drafts cannot be recovered. Delete this draft?', VOID, 'Delete Draft', VOID, tmp_0, VOID, VOID, VOID, VOID, renderDraftChangeOrder$slambda$slambda_0(this.eha_1)));
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    renderDraftChangeOrder$slambdaClass_0 = $;
  }
  return renderDraftChangeOrder$slambdaClass_0;
}
function renderDraftChangeOrder$slambda_2($changeOrder) {
  var i = new (renderDraftChangeOrder$slambda_1())($changeOrder);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function renderDraftChangeOrder$lambda($this$forEach, item) {
  changeRequestItemButton($this$forEach, item, VOID, VOID, ($this$changeRequestItemButton, it) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())($this$changeRequestItemButton.pc());
    var tmp0_elvis_lhs = $this$changeRequestItemButton.cbb_1;
    var p = tmp0_elvis_lhs == null ? $this$changeRequestItemButton : tmp0_elvis_lhs;
    $this$changeRequestItemButton.ebb(p, view);
    view.xbm(false);
    view.zb8(get_rem_0(1));
    var tmp = view.ibb(weight(view, 6.0), get_centered(view));
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_0 = view.cbb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.ebb(p_0, view_0);
    view_0.xbm(false);
    view_0.zb8(get_AppDimensions().mg2_1);
    view_0.jbb(get_centered(view_0), expandIcon(view_0, it));
    view_0.jbb(get_centered(view_0), body(view_0, item.ngp_1));
    view_0.jbb(get_centered(view_0), smallBody(view_0, item.z94().e95_1));
    view.fbb(p_0, view_0);
    view.jbb(tmp, view_0);
    var tmp_0 = view.ibb(weight(view, 1.0), get_centered(view));
    // Inline function 'com.crowpay.views.theming.body' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (TextView())(view.pc());
    var tmp0_elvis_lhs_1 = view.cbb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
    view.ebb(p_1, view_1);
    view_1.jba(view_1.ob6_1.ybe(BodySemantic_getInstance()));
    view_1.bbs(Align_Center_getInstance());
    var tmp_1 = KMutableProperty0();
    var tmp_2 = TextView$_get_content_$ref_4pzcwl_1(view_1);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('content', 0, tmp_1, tmp_2, TextView$_set_content_$ref_pketfb_1(view_1));
    reactiveScope(view_1, ($this$reactiveScope) => {
      var tmp$ret$4 = item.w94();
      this_0.set(tmp$ret$4);
      return Unit_instance;
    });
    view.fbb(p_1, view_1);
    view.jbb(tmp_0, view_1);
    var tmp_3 = view.ibb(weight(view, 1.0), get_centered(view));
    // Inline function 'com.crowpay.views.theming.body' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (TextView())(view.pc());
    var tmp0_elvis_lhs_2 = view.cbb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
    view.ebb(p_2, view_2);
    view_2.jba(view_2.ob6_1.ybe(BodySemantic_getInstance()));
    view_2.bbs(Align_Center_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp_4 = view_2.tb5_1;
    var tmp_5;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength('Draft') === 0) {
      tmp_5 = '\xA0';
    } else {
      tmp_5 = 'Draft';
    }
    tmp_4.fbu(tmp_5);
    view.fbb(p_2, view_2);
    view.jbb(tmp_3, view_2);
    var tmp_6 = view.ibb(weight(view, 1.0), get_centered(view));
    // Inline function 'com.crowpay.views.theming.body' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_3 = new (TextView())(view.pc());
    var tmp0_elvis_lhs_3 = view.cbb_1;
    var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
    view.ebb(p_3, view_3);
    view_3.jba(view_3.ob6_1.ybe(BodySemantic_getInstance()));
    view_3.bbs(Align_Center_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp_7 = view_3.tb5_1;
    var tmp_8;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength('-') === 0) {
      tmp_8 = '\xA0';
    } else {
      tmp_8 = '-';
    }
    tmp_7.fbu(tmp_8);
    view.fbb(p_3, view_3);
    view.jbb(tmp_6, view_3);
    $this$changeRequestItemButton.fbb(p, view);
    return Unit_instance;
  });
  return Unit_instance;
}
function TextView$_get_content_$ref_4pzcwl_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function Separator$_get_shown_$ref_e9a0og(p0) {
  return () => p0.wb8();
}
function Separator$_set_shown_$ref_f1kfq4(p0) {
  return (_this__u8e3s4) => {
    p0.hb7(_this__u8e3s4);
    return Unit_instance;
  };
}
//region block: exports
export {
  renderDraftChangeOrder as renderDraftChangeOrder2act0apujnstk,
};
//endregion

//# sourceMappingURL=draftChangeOrder.mjs.map
